export const environment = {
  production: true,
  title: 'Halifax Live Comedy Club - The Only Independent Comedy Club in Halifax, Nova Scotia',
  apiBaseUrl: 'https://comedystand-api-prod-325405971060.northamerica-northeast1.run.app',
  apiKey: '0b36d521-a26d-43b3-b2c2-6ec6c7ed29f5',
  // Meta Pixel ID — must match backend env META_PIXEL_HALIFAX_LIVE.
  // Drift between the two breaks browser↔CAPI dedup silently.
  metaPixelId: '988229189464954',
  // GA4 measurement ID (format: G-XXXXXXXXXX). Must match backend env
  // GA_HALIFAX_LIVE_MEASUREMENT_ID — browser fires view_item /
  // add_to_cart / begin_checkout / add_payment_info; backend fires
  // purchase + refund via Measurement Protocol. Empty string disables
  // the gtag.js client (no script load, no events from browser).
  gaMeasurementId: '',
  stripe: "pk_live_51NBML4AAx7YpYnj0iQqXwMaXlGmingrLxjiN6aFvTRDBtc3PDAqSobwGoepyc6dKKuks9QgFglh9ItbhzSSsph2j00wAoha9ZD",
  api_keys: {
    google_maps: 'AIzaSyBzXrdEJ6iu5jUPuyVBbkhI2DCIbl2Crds',
    geocoding: 'AIzaSyC8k5OKcs1m02FPFGzOfQs7Zqpj4jZVeLA',
  },
  payments: {
    stripePublishableKey: 'pk_live_51NBML4AAx7YpYnj0iQqXwMaXlGmingrLxjiN6aFvTRDBtc3PDAqSobwGoepyc6dKKuks9QgFglh9ItbhzSSsph2j00wAoha9ZD',
    paypalClientId: 'AYz1234567890abcdef',
    appleMerchantId: 'merchant.com.halifax-live'
  }
}
